import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: () => import('../views/Home.vue'),
  //   meta: { title: '首页' }
  // },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/price',
    name: 'Price',
    component: () => import('../views/Price.vue'),
    meta: { title: '价格' }
  },
  {
    path: '/pay-mobile',
    name: 'PayMobile',
    component: () => import('../views/PayMobile.vue'),
    meta: { title: '价格', keepAlive: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/Login.vue'),
    meta: { title: '欢迎登录' }
  },
  {
    path: '/service-terms',
    name: 'ServiceTerms',
    component: () => import('../views/privacy/ServiceTerms.vue'),
    meta: { title: '服务条款' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/privacy/PrivacyPolicy.vue'),
    meta: { title: '隐私政策' }
  },
  {
    path: '/register-login',
    name: 'RegisterLoginMobile',
    component: () => import('../views/login/components/mobile/RegisterLoginMobile.vue'),
    meta: { title: '用户注册' }
  },
  {
    path: '/reset-password',
    name: 'ResetPasswordMobile',
    component: () => import('../views/login/components/mobile/ResetPasswordMobile.vue'),
    meta: { title: '修改密码' }
  },

  {
    path: '/home',
    name: 'HomeNew',
    component: () => import('../views/HomeNew.vue'),
    meta: { title: '首页' }
  },

  {
    path: '/',
    name: 'AuthorizePage',
    component: () => import('../views/AuthorizePage.vue'),
    meta: { title: '授权页面' }
  },

  {
    path: '/member-mobile',
    name: 'MemberMobile',
    component: () => import('../views/member/index.vue'),
    meta: { title: '价格' }
  },

  // 重定向到首页
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(import.meta.env.VITE_BESE),
  routes
})

// 添加路由守卫来动态修改标题
router.beforeEach((to, from, next) => {
  console.log(to.name)
  // 设置默认标题
  const defaultTitle = '微谱AI色卡平台'

  // 如果路由有定义标题，则使用路由标题，否则使用默认标题
  if (to.meta && to.meta.title) {
    document.title = defaultTitle + ' - ' + to.meta.title
  } else {
    document.title = defaultTitle
  }
  const user = localStorage.getItem('userInfo');
  // 退出登录点击返回 调整到首页
  if(to.name === 'Price' && !user) {
    next('/home')
  } else {
    next()
  }

  
})

export default router